export default "__VITE_ASSET__HXHqVYpb__"